'use client';
import {
  Accordion,
  AccordionContent,
  AccordionPanel,
  AccordionTitle,
} from 'flowbite-react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { childVariants } from '../constants/motion';

// Array of fallback images
const fallbackImages = [
  'affordable-web-design.jpg',
  'ai-automation-consulting.jpg',
  'ai-powered-website-design.jpg',
  'best-paymonthly-website.jpg',
  'custom-website-design.jpg',
  'orlando-web-design.jpg',
  'psd-to-wordPress-services.jpg',
  'real-estate-web-development.jpg',
  'search-engine-optimization.jpg',
  'seo-audit-services.jpg',
  'shopify-expert-services.jpg',
  'web-development.jpg',
  'website-maintenance-services.jpg',
  'wordpress-customization.jpg',
];

// Function to get a random image from the fallback list
const getRandomImage = () => {
  return `/images/faqs/${fallbackImages[Math.floor(Math.random() * fallbackImages.length)]}`;
};

const FaqsSection = ({ title, qaPairs, colouredTitle = '' }) => {
  const selectedImage = getRandomImage();

  return (
    <>
      <section className="w-full" id="faqs">
        <div className="max-w-screen-xl mx-5 lg:mx-auto flex flex-col py-10">
          <h2 className="font-semibold text-center text-neutral-800 pb-6">
            {title}{' '}
            <div className="text-colorOrange-700 inline">{colouredTitle}</div>
          </h2>
          <div className="flex flex-col md:flex-row rounded-lg">
            <div className="flex-1 basis-4/5 order-2 md:order-1">
              <div className="flex flex-col justify-center h-full px-5">
                <Accordion className="accordion-features" collapseAll>
                  {qaPairs.map(({ question, answer }, index) => (
                    <AccordionPanel key={index}>
                      <AccordionTitle className="py-0">
                        {question}
                      </AccordionTitle>
                      <AccordionContent className="accordion-content">
                        <p className="mb-2 text-gray-800 dark:text-gray-400 p-4">
                          {answer}
                        </p>
                      </AccordionContent>
                    </AccordionPanel>
                  ))}
                </Accordion>
              </div>
            </div>
            {/* <motion.div
              variants={childVariants}
              className="bg-blue-100 flex-1 rounded-2xl basis-2/4 order-1 md:order-2 relative"
            >
              <Image
                src={selectedImage}
                alt={title}
                fill
                className="z-50 absolute w-full h-full object-cover rounded-2xl"
              />
            </motion.div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqsSection;
